// @flow

// Libs
import _map from 'lodash/map'
import _groupBy from 'lodash/groupBy'
import _flatMap from 'lodash/flatMap'
import _reverse from 'lodash/reverse'
import _sortBy from 'lodash/sortBy'
import _keys from 'lodash/keys'

// Constants
import {
  PROP_LABEL,
  PROP_START_DATE,
} from 'fc-model-seasons'

// Types
import type {
  Season,
} from 'fc-model-seasons/types'

// Exports
export default function sort (seasons: Array<Season>): Array<Season> {
  const groups: { [string]: ?Array<Season> } = _groupBy(seasons, function ({[PROP_LABEL]: label}: Season): string {
    return `${label}`.substr(0, 1)
  })

  const sortedGroupIds: Array<string> = _sortBy(_keys(groups))

  return _flatMap(_map(sortedGroupIds, (groupId: string): Array<Season> => {
    return _reverse(_sortBy(groups[groupId], PROP_START_DATE))
  }))
}
